import SectionHeader from "./SectionHeader";
import { works } from "@/mocks/manhwa";

export default function HotNew() {
  const hot = works.filter((w) => w.isHot).slice(0, 4);
  const fresh = works.filter((w) => w.isNew).slice(0, 3);

  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          tag="热门连载 · 新作上线"
          title="同好都在追的爆款韩漫"
          desc="基于真实追更热度与连载进度推荐的热门作品，加上最近上线并即时标记的新作，追更不走弯路。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="mb-4 flex items-center gap-2">
              <span className="inline-flex h-8 items-center gap-1.5 rounded-full bg-primary-500 px-4 text-sm font-semibold text-background-50">
                <i className="ri-fire-line text-base"></i>
                热门连载
              </span>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {hot.map((item, i) => (
                <article key={item.id} className="group flex gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1">
                  <div className="relative shrink-0 overflow-hidden rounded-xl">
                    <img src={item.cover} alt={`${item.title} 热门韩漫连载封面`} className="h-40 w-28 object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-44 md:w-32" />
                    <span className="absolute left-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-background-50">
                      {i + 1}
                    </span>
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                    <p className="mt-0.5 text-xs text-foreground-500">
                      {item.author} · {item.genre}
                    </p>
                    <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.description}</p>
                    <div className="mt-auto flex items-center justify-between pt-3">
                      <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2.5 py-1 text-xs font-semibold text-primary-700">
                        {item.lastChapter}
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                        <i className="ri-eye-line text-sm"></i>
                        {item.views}
                      </span>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div>
            <div className="mb-4 flex items-center gap-2">
              <span className="inline-flex h-8 items-center gap-1.5 rounded-full bg-accent-500 px-4 text-sm font-semibold text-background-50">
                <i className="ri-sparkling-2-line text-base"></i>
                新作上线
              </span>
            </div>
            <div className="flex flex-col gap-4">
              {fresh.map((item) => (
                <article key={item.id} className="group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1">
                  <img src={item.cover} alt={`${item.title} 新作韩漫封面`} className="h-24 w-16 shrink-0 rounded-lg object-cover object-top" />
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">{item.title}</h3>
                    <p className="mt-0.5 text-xs text-foreground-500">{item.genre}</p>
                    <div className="mt-2 flex items-center gap-2">
                      <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-700">
                        新作
                      </span>
                      <span className="text-xs font-medium text-primary-600">{item.lastChapter}</span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition-colors group-hover:text-primary-500"></i>
                </article>
              ))}
              <a
                href="#genres"
                className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-accent-300 text-sm font-medium text-accent-700 transition-colors hover:bg-accent-100"
              >
                查看全部新作
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}